import { render, staticRenderFns } from "./Fullstory.vue?vue&type=template&id=bef7acbe&"
import script from "./Fullstory.vue?vue&type=script&lang=js&"
export * from "./Fullstory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports